/* eslint-disable */
import ApiService from '@/services/Base/ApiService';

const getDefaultState = () => {
  return {
    results: null,
    isLoading: false,

    twoWayResults: {},
    threeWayResults: {},

    uiResultsTwoWay: null,
    uiResultsThreeWay: null,

    savedUiDetails: {},
  }
}

const state = getDefaultState()

const getters = {
  getResults(state) {
    return state.results;
  },
  getUiResultsTwoWay(state) {
    return state.uiResultsTwoWay;
  },
  getUiResultsThreeWay(state) {
    return state.uiResultsThreeWay;
  },
}

const mutations = {
  setResults(state, data) {
    state.results = data;
  },
  setUiResultsTwoWay(state, data) {
    state.uiResultsTwoWay = data;
  },
  setUiResultsThreeWay(state, data) {
    state.uiResultsThreeWay = data;
  },
}

const actions = {
  async fetchAncientDetails(context, groupedSourceCodes) {
    try {
      if (!groupedSourceCodes) {
        return;
      }
      const saveDetail = context.state.savedUiDetails[groupedSourceCodes.join(',')]
      if (saveDetail) {
        return saveDetail;
      } else {
        context.state.isLoading = true;
        const response = await ApiService.get('AncientProxDetail');
        context.state.isLoading = false;
        
        if (response.statusCode === 200) {
          const filtered = response.result.filter(x => groupedSourceCodes.includes(x.sourceCode));
          context.state.savedUiDetails[groupedSourceCodes.join(',')] = filtered;
          return filtered;
        } else {
          throw error;
        }
      }
      
    } catch (error) {
      throw error;
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
